import fonts from '@galo-monitor/styles/fonts'

export default {
  // loadingType: 'linear',
  selection: false,
  columnsButton: false,
  grouping: false,
  filtering: false,
  debounceInterval: 500,
  pageSizeOptions: [10, 20, 50, 100],
  initialPage: 0,
  actionsColumnIndex: -1,
  emptyRowsWhenPaging: false,
  toolbar: true,
  search: true,
  draggable: false,
  addRowPosition: 'first',
  toolbarProps: {
    color: 'primary'
  },
  paginationIconButtonProps: {
    size: 'small'
  },
  headerStyle: {
    zIndex: 11,
    fontWeight: fonts.fontWeight.bold,
    padding: '10px 16px'
  },
  actionsCellDivStyle: {
    justifyContent: 'center'
  },
  actionsCellStyle: {
    width: 'auto'
  },
  searchFieldProps: {
    type: 'search'
  }
}
